var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentLayoutComponent,{tag:"component",staticClass:"relative bg-dark-light rounded-lg p-3 h-[calc(100%-40px)]"})
}
var staticRenderFns = []

export { render, staticRenderFns }